import { ParseKeys } from 'i18next'
import { EventAuditEnum } from '~/shared/config/enums'

export const eventEnumLabels: Record<EventAuditEnum, ParseKeys> = {
  [EventAuditEnum.CREATED]: 'create',
  [EventAuditEnum.UPDATED]: 'edit',
  [EventAuditEnum.DELETED]: 'delete',
  [EventAuditEnum.RESTORED]: 'restore',
  [EventAuditEnum.BALANCE_TRANSFER]: 'balance transfer',
}
